const JAVA_API_PREFIX = '/dataapi';
const NODE_API_PREFIX = '/apis';

/**
 * 判断 url 是否是 java 后端接口前缀
 * @param {string} url URL
 * @returns {boolean}
 */
const isJavaApiPrefix = (url: string) => {
  if (!url) return false;
  return url.startsWith(JAVA_API_PREFIX);
};

/**
 * 判断 url 是否是绝对路径
 * @param {string} url URL
 * @returns {boolean}
 */
const isAbsoluteURL = (url: string) => /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);

/**
 * url 合并
 * @param {string} baseURL
 * @param {string} relativeURL
 * @returns
 */
const combineURLs = (baseURL: string, relativeURL: string) => {
  return relativeURL
    ? `${baseURL.replace(/\/+$/, '')}/${relativeURL.replace(/^\/+/, '')}`
    : baseURL;
};

// dataapi 前缀直接转发到 java 服务；否则转发到 node 层的 apiv3 路由
export const axiosUrlFormat = (url: string) => {
  if (isAbsoluteURL(url)) {
    return url;
  }
  return isJavaApiPrefix(url) ? url : combineURLs(NODE_API_PREFIX, url);
};
